export default __webpack_public_path__ + "static/media/Corsairs-treasure-02.b734e84e.png";